import React from 'react'
import PropTypes from 'prop-types'
import InfoOctagonIcon from 'asterX-UI/Icons/InfoOctagonIcon'
import { Button, Dialog, DialogActions, DialogContent, useMediaQuery } from '@material-ui/core'
import ModalTitle from 'asterX-UI/Modals/ModalTitle'
import { MODAL_STYLES } from 'asterX-UI/theme.constant'
import { AlertFutureIcon, AlertOctagonIcon } from 'asterX-UI/Icons'
import { useInfoModalStyles } from './modals.styles'

const InfoModal = ({
  open,
  onClose,
  variant = '',
  title = '',
  btnText = 'OK',
  iconComponent = null,
  isButtonHidden,
  maxWidth,
  ...other
}) => {
  const classes = useInfoModalStyles({ variant, maxWidth })
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('lg'))

  const getIconComponent = () => {
    const [info, warning, error, success] = MODAL_STYLES.variant
    if (variant === info) {
      return <InfoOctagonIcon />
    }
    if (variant === warning) {
      return <AlertOctagonIcon />
    }
    if (variant === error) {
      return <AlertFutureIcon />
    }
    if (variant === success) {
      return <AlertOctagonIcon />
    }
    return <AlertOctagonIcon />
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={isMobile ? 'xs' : 'sm'}
      classes={{ paper: classes.paper }}
      fullWidth
      {...other}
    >
      <ModalTitle onClose={onClose} iconComponent={iconComponent || getIconComponent()} style={{ color: '#101828' }}>
        {title}
      </ModalTitle>
      <DialogContent>{other.children}</DialogContent>
      {isButtonHidden ? (
        ''
      ) : (
        <DialogActions>
          <Button variant={'outlined'} fullWidth onClick={onClose}>
            {btnText}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  )
}
export default InfoModal
InfoModal.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(MODAL_STYLES.variant),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.string])
}
